export default __webpack_public_path__ + "static/media/formosan-2.96212994.jpg";